import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import OAuth from "../../oauth";
var auth = new OAuth();
export default function (_x, _x2, _x3) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var user, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return auth.currentUser();
        case 1:
          user = _context.sent;
          if (user) {
            if (user.get('email_verified_at') || user.get('mobile_verified_at')) {
              next('/');
            } else {
              next();
            }
          } else {
            next('/login');
          }
          _context.next = 3;
          break;
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          // Handle different error types appropriately
          if (_t.response && _t.response.status === 403) {
            // 403 means user is authenticated but needs verification - stay on verify page
            next();
          } else if (_t.response && (_t.response.status === 401 || _t.response.status === 429)) {
            // 401/429 means user needs to login again
            next('/login');
          } else {
            // For other errors, redirect to login for safety
            next('/login');
          }
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _ref.apply(this, arguments);
}